import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import Mask from "./Mask";

interface PromiseTrackingMaskProps {
  area: string;
  text?: string;
  coverViewport?: boolean;
  withoutText?: boolean;
}

/**
 * How to use: wrap a promise call in trackPromise, second argument is the name of the area covered by the PromiseTrackingMask. The PromiseTrackingMask should have a matching area declared.
 */
const PromiseTrackingMask: React.FC<PromiseTrackingMaskProps> = ({
  area,
  text,
  coverViewport = false,
  withoutText = false
}) => {
  const { promiseInProgress } = usePromiseTracker({ area });

  return (
    <>{promiseInProgress && area && <Mask text={text} coverViewport={coverViewport} withoutText={withoutText} />}</>
  );
};

export default PromiseTrackingMask;
